import { render, staticRenderFns } from "./card-basic.component.vue?vue&type=template&id=06d24f46&scoped=true&"
import script from "./card-basic.component.vue?vue&type=script&lang=ts&"
export * from "./card-basic.component.vue?vue&type=script&lang=ts&"
import style0 from "./card-basic.component.vue?vue&type=style&index=0&id=06d24f46&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d24f46",
  null
  
)

export default component.exports